<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Şirket Faaliyet Formları">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>Ad Soyad</th>
                    <th>E-Posta</th>
                    <th>Telefon</th>
                    <th>SMS Onayı</th>
                    <th>E-Posta Onayı</th>
                    <th>Telefon Onayı</th>
                    <th>Onay Durumu</th>
                    <th>Tarih</th>
                  </thead>
                  <tr v-for="form in forms" :key="form.id">
                    <td>{{ form.id }}</td>
                    <td>{{ form.name }}</td>
                    <td>{{ form.email }}</td>
                    <td>{{ form.phone }}</td>
                    <td class="text-center">
                      <span v-if="form.smsConfirmation" class="badge badge-success"
                        >Onaylandı</span
                      >
                      <span v-else class="badge badge-warning">Onaylanmadı</span>
                    </td>
                    <td class="text-center">
                      <span v-if="form.emailConfirmation" class="badge badge-success"
                        >Onaylandı</span
                      >
                      <span v-else class="badge badge-warning">Onaylanmadı</span>
                    </td>
                    <td class="text-center">
                      <span v-if="form.phoneConfirmation" class="badge badge-success"
                        >Onaylandı</span
                      >
                      <span v-else class="badge badge-warning">Onaylanmadı</span>
                    </td>

                    <td>
                      <span v-if="form.subscribed" class="badge badge-success"
                        >Onaylandı</span
                      >
                      <span v-else class="badge badge-warning">Onaylanmadı</span>
                    </td>
                    <td>{{ form.createdAt }}</td>
                  </tr>
                  <thead>
                    <th>#</th>
                    <th>Ad Soyad</th>
                    <th>E-Posta</th>
                    <th>Telefon</th>
                    <th>SMS Onayı</th>
                    <th>E-Posta Onayı</th>
                    <th>Telefon Onayı</th>
                    <th>Onay Durumu</th>
                    <th>Tarih</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
          <b-button
            class="float-left mt-2"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="exportData()"
            >Dışa Aktar
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";

import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      forms: [],
    };
  },
  watch: {},
  methods: {
    exportData() {
      window.open(
        `${settings.apiBaseUrl}/api/v1/export/forms/company-activities?hl=${this.$i18n.locale}`,
        "_blank"
      );
    },
    getFormCompanyActivities() {
      endpoints
        .getFormCompanyActivities(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.forms = [...data.response];
          console.log(this.forms);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getFormCompanyActivities();
  },
};
</script>
